import { Routes } from '@angular/router';
import { Routing } from '@medicalapp/shared-core';
import { authGuard } from '@core/guards/auth.guard';
import { unauthGuard } from '@core/guards/unauth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: Routing.Secure,
    pathMatch: 'full',
  },
  {
    path: Routing.Auth,
    loadChildren: () =>
      import('@core/layouts/public-layout/public-layout.routes').then(
        (m) => m.publicRoutes
      ),
    canActivate: [unauthGuard],
  },
  {
    path: Routing.ContactUs,
    title: 'Contact Us | HMS Patient Portal',
    loadComponent: () =>
      import('@features/contact-us/contact-us.component').then(
        (m) => m.ContactUsComponent
      ),
  },
  {
    path: Routing.ConfirmAppointment,
    title: 'Confirm Appointment | HMS Patient Portal',
    loadComponent: () =>
      import('@features/confirm-appointment/confirm-appointment.component').then(
        (m) => m.ConfirmAppointmentComponent
      ),
  },
  {
    path: Routing.ConfirmRecurrence,
    title: 'Confirm Appointments | HMS Patient Portal',
    loadComponent: () =>
      import('@features/confirm-appointment/confirm-appointment.component').then(
        (m) => m.ConfirmAppointmentComponent
      ),
  },
  {
    path: Routing.AcceptTerms,
    title: 'Review & Accept Terms | HMS Patient Portal',
    loadComponent: () =>
      import('@features/auth/accept-terms/accept-terms.component').then(
        (m) => m.AcceptTermsComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: Routing.DocumentViewer,
    loadComponent: () =>
      import('@features/document-viewer/document-viewer.component').then(
        (m) => m.DocumentViewerComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: Routing.PrintTemplate,
    loadComponent: () =>
      import('@features/print-template/print-template.component').then(
        (m) => m.PrintTemplateComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: Routing.Secure,
    loadChildren: () =>
      import('@core/layouts/secure-layout/secure-layout.routes').then(
        (m) => m.secureRoutes
      ),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: Routing.Dashboard,
  },
];
